module.exports = __webpack_public_path__ + "img/illu-lungs.76fd3c5d.svg";